import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaTruck,
  FaCalendarDay,
  FaCalendarWeek,
  FaCalendarAlt,
  FaCalendarCheck,
  FaGift,
  FaRocket,
  FaUsers,
  FaMotorcycle,
  FaCar,
  FaHandshake,
  FaChartLine,
  FaClock,
  FaAward,
  FaArrowRight,
  FaChevronLeft,
  FaChevronRight,
} from 'react-icons/fa';
import './Motorista.css';

import motoristaImg1 from '../assets/images/motoristaedonodacarga/telamotorista1.jpg';
import motoristaImg2 from '../assets/images/motoristaedonodacarga/telamotorista2.jpg';

const useScrollAnimation = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -30px 0px' }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }, []);
};

const Motorista = () => {
  const navigate = useNavigate(); // ← ADICIONADO para navegação

  const [currentSlide, setCurrentSlide] = useState(0);
  const slideIntervalRef = useRef(null);

  const slides = [motoristaImg1, motoristaImg2];

  useEffect(() => {
    slideIntervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000);

    return () => {
      if (slideIntervalRef.current) {
        clearInterval(slideIntervalRef.current);
        slideIntervalRef.current = null;
      }
    };
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    if (slideIntervalRef.current) {
      clearInterval(slideIntervalRef.current);
      slideIntervalRef.current = null;
    }
    slideIntervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000);
  };

  const nextSlide = () => goToSlide((currentSlide + 1) % slides.length);
  const prevSlide = () => goToSlide((currentSlide - 1 + slides.length) % slides.length);

  // 🔥 HANDLER DO BOTÃO CADASTRAR
  const handleCadastroClick = () => navigate('/cadastro');

  useScrollAnimation();

  return (
    <div className="motorista-page">
      {/* ===== SEÇÃO HERO com CARROSSEL ===== */}
      <div className="motorista-hero-section">
        <div className="motorista-carousel">
          <div
            className="motorista-carousel-track"
            style={{
              transform: `translateX(-${currentSlide * (100 / slides.length)}%)`
            }}
          >
            {slides.map((img, idx) => (
              <div className="motorista-carousel-slide" key={idx}>
                <img src={img} alt={`Motorista ${idx + 1}`} loading="lazy" />
              </div>
            ))}
          </div>

          <button className="motorista-carousel-btn prev" onClick={prevSlide} aria-label="Anterior">
            <FaChevronLeft />
          </button>
          <button className="motorista-carousel-btn next" onClick={nextSlide} aria-label="Seguinte">
            <FaChevronRight />
          </button>

          <div className="motorista-carousel-dots">
            {slides.map((_, idx) => (
              <button
                key={idx}
                className={`motorista-dot ${idx === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(idx)}
                aria-label={`Ir para o slide ${idx + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="motorista-hero-overlay-light"></div>
        <div className="motorista-hero-content">
          <h1 className="hero-title">
            Seja um Motorista<br />
            <span className="highlight-carga">Carga Fácil</span>
          </h1>
        </div>
      </div>

      {/* ===== SEÇÃO INFORMATIVA ===== */}
      <div className="motorista-about-section">
        <div className="motorista-about-header animate-on-scroll">
          <h2>O seu veículo, o seu negócio</h2>
          <p className="highlight-text">
            <span className="highlight-icon"><FaArrowRight /></span>
            Transforme o seu veículo numa fonte de rendimento. Transporte cargas
            para clientes particulares e empresas em todo o país.
          </p>
          <p className="sub-text">
            Seja você um motoqueiro, taxista, dono de uma pickup ou de um camião,
            a Carga Fácil conecta-o a quem precisa de transporte de cargas.
          </p>
        </div>

        <div className="motorista-vehicle-grid">
          <div className="vehicle-card animate-on-scroll">
            <FaMotorcycle className="vehicle-icon float-icon" />
            <h3>Moto / Txopela</h3>
            <p>Perfeito para entregas rápidas de documentos, encomendas pequenas e compras.</p>
          </div>
          <div className="vehicle-card animate-on-scroll" style={{ animationDelay: '0.15s' }}>
            <FaCar className="vehicle-icon float-icon" />
            <h3>Viatura Ligeira / Sedan</h3>
            <p>Ideal para transportar caixas, malas e cargas leves com segurança.</p>
          </div>
          <div className="vehicle-card animate-on-scroll" style={{ animationDelay: '0.3s' }}>
            <FaTruck className="vehicle-icon float-icon" />
            <h3>Pickup / Van / Camião</h3>
            <p>Para cargas maiores, mudanças, materiais de construção e cargas industriais.</p>
          </div>
        </div>

        <div className="motorista-cta-block animate-on-scroll">
          <p>
            <strong>Não importa o tamanho do seu veículo</strong> - 
            há sempre um cliente à sua espera. Cadastre-se e comece a lucrar.
          </p>
        </div>
      </div>

      {/* ===== SEÇÃO DE PLANOS ===== */}
      <div className="motorista-plans-section">
        <div className="motorista-plans-header animate-on-scroll">
          <h2>Escolha o seu plano de acesso</h2>
          <p>
            Sem comissões por viagem. Pague apenas pelo tempo de uso da plataforma.
            Flexível, transparente e feito para si.
          </p>
        </div>

        <div className="motorista-plans-grid">
          <div className="motorista-plan-card animate-on-scroll">
            <FaCalendarDay className="plan-icon float-icon" />
            <h3>Diário</h3>
            <p className="plan-desc">Ideal para testar ou usar em dias específicos.</p>
          </div>
          <div className="motorista-plan-card featured animate-on-scroll" style={{ animationDelay: '0.15s' }}>
            <FaCalendarWeek className="plan-icon float-icon" />
            <h3>Semanal</h3>
            <p className="plan-desc">Para quem quer consistência e mais rentabilidade.</p>
            <span className="plan-badge">Mais usado</span>
          </div>
          <div className="motorista-plan-card animate-on-scroll" style={{ animationDelay: '0.3s' }}>
            <FaCalendarAlt className="plan-icon float-icon" />
            <h3>Quinzenal</h3>
            <p className="plan-desc">Perfeito para rotinas regulares.</p>
          </div>
          <div className="motorista-plan-card animate-on-scroll" style={{ animationDelay: '0.45s' }}>
            <FaCalendarCheck className="plan-icon float-icon" />
            <h3>Mensal</h3>
            <p className="plan-desc">Máxima economia para uso intensivo.</p>
          </div>
        </div>
      </div>

      {/* ===== BANNER PROMOCIONAL ===== */}
      <div className="motorista-promo-banner animate-on-scroll">
        <div className="promo-content">
          <FaRocket className="promo-icon pulse-icon" />
          <div className="promo-text">
            <h3>Oferta especial para os primeiros 50 motoristas!</h3>
            <p>
              <strong>Antes do lançamento:</strong> 30 dias de uso gratuito.
              <br />
              <strong>Após o lançamento:</strong> 15 dias de uso gratuito para os
              primeiros 50 motoristas que se cadastrarem.
            </p>
            {/* 🔥 BOTÃO CADASTRAR ADICIONADO */}
            <button className="promo-btn" onClick={handleCadastroClick}>
              Cadastrar-me agora
            </button>
          </div>
          <FaGift className="promo-gift pulse-icon" />
        </div>
      </div>

      {/* ===== COMO FUNCIONA ===== */}
      <div className="motorista-how-it-works">
        <h2 className="animate-on-scroll">Como funciona e como ganhar dinheiro</h2>
        <div className="motorista-steps-grid">
          <div className="step-card animate-on-scroll">
            <div className="step-number">1</div>
            <h3>Cadastre-se gratuitamente</h3>
            <p>Crie a sua conta na plataforma em poucos minutos.</p>
          </div>
          <div className="step-card animate-on-scroll" style={{ animationDelay: '0.15s' }}>
            <div className="step-number">2</div>
            <h3>Escolha o seu plano</h3>
            <p>Selecione o plano (diário, semanal, quinzenal ou mensal) que melhor se adapta à sua rotina.</p>
          </div>
          <div className="step-card animate-on-scroll" style={{ animationDelay: '0.3s' }}>
            <div className="step-number">3</div>
            <h3>Receba solicitações</h3>
            <p>Clientes e empresas enviam pedidos de transporte – aceite os que preferir.</p>
          </div>
          <div className="step-card animate-on-scroll" style={{ animationDelay: '0.45s' }}>
            <div className="step-number">4</div>
            <h3>Transporte e ganhe</h3>
            <p>Realize o transporte, receba o pagamento diretamente do cliente e fique com 100% do valor.</p>
          </div>
        </div>
      </div>

      {/* ===== CLIENTES E EMPRESAS ===== */}
      <div className="motorista-clients-section">
        <h2 className="animate-on-scroll">Quem pode contratar os seus serviços?</h2>
        <div className="motorista-clients-grid">
          <div className="client-card animate-on-scroll">
            <FaUsers className="client-icon float-icon" />
            <h3>Clientes Particulares</h3>
            <p>Pessoas que precisam transportar uma encomenda, uma mudança ou uma compra.</p>
          </div>
          <div className="client-card animate-on-scroll" style={{ animationDelay: '0.15s' }}>
            <FaHandshake className="client-icon float-icon" />
            <h3>Empresas Parceiras</h3>
            <p>Negócios que necessitam de logística regular para entregas de produtos e materiais.</p>
          </div>
          <div className="client-card animate-on-scroll" style={{ animationDelay: '0.3s' }}>
            <FaChartLine className="client-icon float-icon" />
            <h3>Aumente os seus ganhos</h3>
            <p>Com contratos frequentes e clientes fiéis, maximize o seu rendimento mensal.</p>
          </div>
        </div>
      </div>

      {/* ===== BENEFÍCIOS ADICIONAIS ===== */}
      <div className="motorista-bonus-section">
        <div className="bonus-grid">
          <div className="bonus-item animate-on-scroll">
            <FaClock className="bonus-icon float-icon" />
            <h4>Trabalhe quando quiser</h4>
            <p>Flexibilidade total para definir os seus horários.</p>
          </div>
          <div className="bonus-item animate-on-scroll" style={{ animationDelay: '0.15s' }}>
            <FaAward className="bonus-icon float-icon" />
            <h4>Sem comissões</h4>
            <p>Fique com 100% do valor do transporte – zero taxas por viagem.</p>
          </div>
          <div className="bonus-item animate-on-scroll" style={{ animationDelay: '0.3s' }}>
            <FaUsers className="bonus-icon float-icon" />
            <h4>Comunidade de motoristas</h4>
            <p>Troque experiências, dicas e cresça com outros profissionais.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Motorista;